import { useEffect, useState, type RefObject } from 'react'

interface AnchorPosition {
  top: number
  left: number
}

// Tracks the inline placeholder for the portalled glow. Sampled per frame
// because expanding a section animates Accordion.Content's height, which moves
// the anchor without firing scroll or resize.
export const useAnchorRect = (
  anchorRef: RefObject<HTMLElement | null>
): AnchorPosition | null => {
  const [position, setPosition] = useState<AnchorPosition | null>(null)

  useEffect(() => {
    let frame = 0

    const sample = () => {
      const anchor = anchorRef.current
      if (anchor) {
        const { top, left } = anchor.getBoundingClientRect()
        setPosition((prev) =>
          prev &&
          Math.abs(prev.top - top) < 0.5 &&
          Math.abs(prev.left - left) < 0.5
            ? prev
            : { top, left }
        )
      }
      frame = requestAnimationFrame(sample)
    }

    sample()
    return () => cancelAnimationFrame(frame)
  }, [anchorRef])

  return position
}
